(function (angular) {
    'use strict';

    angular
        .module('app.grievance')
        .controller('app.grievance.grievanceSuccessController', [
            '$state',
            grievanceSuccessController
        ]);

    function grievanceSuccessController($state) {
        var vm = this;
        vm.continue = goToMainPage;

        function goToMainPage() {
            $state.go(siteContent.landingPath);
        }
    }
})(angular);